import { render, staticRenderFns } from "./rwlb.vue?vue&type=template&id=bc3e93e0&scoped=true&"
import script from "./rwlb.vue?vue&type=script&lang=js&"
export * from "./rwlb.vue?vue&type=script&lang=js&"
import style0 from "./rwlb.vue?vue&type=style&index=0&id=bc3e93e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3e93e0",
  null
  
)

export default component.exports